import { render, staticRenderFns } from "./SupplierCommunicateAdd.vue?vue&type=template&id=2c17c3ac&scoped=true"
import script from "./SupplierCommunicateAdd.vue?vue&type=script&lang=ts"
export * from "./SupplierCommunicateAdd.vue?vue&type=script&lang=ts"
import style0 from "./SupplierCommunicateAdd.vue?vue&type=style&index=0&id=2c17c3ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c17c3ac",
  null
  
)

export default component.exports